import React from 'react';
import {Tabs} from 'antd';
import ProjectInfoTab from './ProjectInfoTab';
import ProjectTermsTab from './ProjectTermsTab';
import ProjectWordsTab from './ProjectWordsTab';
import ProjectDomainsTab from './ProjectDomainsTab';
import ProjectMenusTab from './ProjectMenusTab';

// 재사용 가능한 프로젝트 탭 컴포넌트
// props: { project, pjtId, defaultActiveKey, onEdit, onDelete, items }
// items를 전달하면 해당 구성으로 렌더링하며, 전달하지 않으면 기본 5개 탭으로 렌더링
const ProjectTabs = ({ project, pjtId, defaultActiveKey = 'info', onEdit, onDelete, items }) => {
  const computedItems = items || [
    {
      key: 'info',
      label: '프로젝트 정보',
      children: (
        <ProjectInfoTab project={project} onEdit={onEdit} onDelete={onDelete} />
      ),
    },
    {
      key: 'menu',
      label: '프로젝트 메뉴',
      children: (
        <ProjectMenusTab pjtId={pjtId} />
      ),
    },
    {
      key: 'term',
      label: '프로젝트 용어',
      children: (
        <ProjectTermsTab pjtId={pjtId} />
      ),
    },
    {
      key: 'word',
      label: '프로젝트 단어',
      children: (
        <ProjectWordsTab pjtId={pjtId} />
      ),
    },
    {
      key: 'domain',
      label: '프로젝트 도메인',
      children: (
        <ProjectDomainsTab pjtId={pjtId} />
      ),
    },
  ];

  return (
    <Tabs defaultActiveKey={defaultActiveKey} items={computedItems} />
  );
};

export default ProjectTabs;
